<template>
  <button v-if="!toggle_select" type="button" class="btn btn-outline-primary btn-toggle-select" @click.prevent="toggle_select=!toggle_select" :disabled="processing">
    <i class="fas fa-circle-notch fa-spin" v-if="processing"></i>
    Change status
  </button>
  <div v-else class="input-group">
    <select class="form-control" v-model="status" @change.prevent="changeProductStatus">
      <option value="pending">Pending</option>
      <option value="processing">Processing</option>
      <option value="ready">Ready</option>
      <option value="dispatched">Dispatched</option>
      <option value="delivered">Delivered</option>
    </select>
    <div v-if="processing" class="input-group-append">
      <button type="button" class="btn btn-outline-primary" :disabled="processing">
        <i class="fas fa-circle-notch fa-spin" v-if="processing"></i>
      </button>
    </div>
    <div v-if="!processing" class="input-group-append">
      <button type="button" class="btn btn-outline-secondary" @click.prevent="toggle_select=!toggle_select">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderChangeProductStatus',
  props: ['order_id', 'order_product_id'],
  data () {
    return {
      toggle_select: false,
      processing: false,

      status: null
    }
  },
  methods: {
    changeProductStatus () {
      this.processing = true

      axios.patch(process.env.URLS_POS_API + '/orders/' + this.order_id + '/products/' + this.order_product_id + '/status', {
        ids: [this.order_product_id],
        status: this.status
      }).then((response) => {
        this.$parent.$parent.$parent.fetchOrder()
      }).catch(error => {
        let errorMessage = 'Failed to update the product status.'
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage += ' ' + error.response.data.message
        }
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)
      }).finally(() => {
        this.processing = false
        this.toggle_select = false
      })
    }
  }
}
</script>

<style scoped>
.btn-toggle-select,
.input-group {
  width: 200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/order/partials/ChangeProductStatus.vue